export default "__VITE_ASSET__Cv3x3dUz__"